export default {"src":"/_next/static/media/doc_grey.7907a7e2.svg","height":35,"width":28};